const $ = window.jQuery;
import _ from 'lodash';

const Pikaday = require('pikaday');
const moment = require('moment');

$(() => {
    let $container = $('.event-filters');

    if (!$container.length) {
        return;
    }

    let upcomingCollapsed = false;
    let filtering = false;

    let filters = {
        date: false,
        type: false,
        past: false,
    };

    let $filters = $('.event-filters .aam__select-input');
    let $two_day_container = $('.two-day-event-feed__wrap');
    let $upcoming = $('.card-feed--upcoming-events').first();
    let $cards = $two_day_container.find('.card-feed__cards').first();
    let $sticky = $('.event-filters--sticky').first();
    let two_day_offset = $('body > .event-filters')
        .first()
        .offset().top;
    let two_day_height = $two_day_container.outerHeight(true);
    let sticky_active = false;
    let mobile_filters_active = false;
    let $mobile_filters = $('.event-filters__mobile');
    let $date_pickers = $('input[type="text"][name="specific-date"]');
    let specific_date = false;

    const offset = $upcoming.attr('data-offset');
    const post_url = $upcoming.attr('data-post-url');
    const card_url = $upcoming.attr('data-card-url');

    const $mobile_filter_apply = $('.event-filters__mobile-apply-button');
    const $mobile_filter_toggle = $(
        '.event-filters__mobile-filters--toggle,.event-filters__mobile-close',
    );

    setTimeLinks();

    _.each($filters, filter => {
        const $filter = $(filter);
        $filter.on('change', function(e) {
            filters[$(this).attr('name')] = $(this)
                .val()
                .trim();
            $container.trigger('filterChange');
        });
    });

    _.each($date_pickers, picker => {
        const $picker = $(picker);
        const date_picker = new Pikaday({
            field: $picker[0],
            bound: false,
            format: 'YYYY-M-D',
            keyboardInput: false,
            onSelect: date => {
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                const is_mobile = !$picker.is('#specific-date-desktop');

                specific_date = { day, month, year };
                filters['date'] = 'specific-date';
                const placeholder = $('#select-date').siblings(
                    '.aam__select-placeholder',
                );
                placeholder.html(`${month}/${day}/${year}`);

                if (!is_mobile) {
                    setTimeout(
                        () =>
                            $picker
                                .closest(
                                    '.aam__select.aam__select--expanded',
                                )[0]
                                .click(),
                        250,
                    );
                    $container.trigger('filterChange');
                }
                //hero - calendar__featured - text - title;
            },
            i18n: {
                previousMonth: 'Previous Month',
                nextMonth: 'Next Month',
                months: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December',
                ],
                weekdays: [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday',
                ],
                weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
            },
        });
        const outer = $picker
            .parent()
            .parent()
            .parent()
            .parent();
        outer.trigger('update-height');
    });

    $('input[type="radio"][name="date"]').on('change', function() {
        const $appended = $(
            '.aam__radio__appended-item[data-value="specific-date"]',
        ).first();
        if ($(this).val() === 'specific-date') {
            if (!$appended.hasClass('--show-calendar')) {
                $appended.addClass('--show-calendar');
            }
        } else {
            if ($appended.hasClass('--show-calendar')) {
                $appended.removeClass('--show-calendar');
            }
        }
    });

    $mobile_filter_apply.on('click', () => {
        const date = $mobile_filters.find('input[name="date"]:checked').val();
        const type = $mobile_filters.find('input[name="type"]:checked').val();

        if (date) {
            filters['date'] = date;
        }

        if (type) {
            filters['type'] = date;
        }

        _.each($filters, filter => {
            const $filter = $(filter);
            const name = $filter.attr('name');
            $filter.val(filters[name]);
            const $placeholder = $filter
                .parent()
                .find('.aam__select-placeholder')
                .first();
            const placeholder_text = $filter.parent().attr('data-placeholder');
            const text = $filter
                .find('option:selected')
                .text()
                .trim();
            const value = $filter.val();

            $placeholder.html(value ? text : placeholder_text);
        });

        $container.trigger('filterChange');

        $mobile_filter_toggle[0].click();
    });

    $mobile_filter_toggle.on('click', () => {
        if (!mobile_filters_active) {
            $mobile_filters.addClass(
                'event-filters__mobile--active animated fadeInUpBig',
            );
            $mobile_filters.one('animationend', () => {
                mobile_filters_active = true;
                $mobile_filters.removeClass('animated fadeInUpBig');
            });
        } else {
            $mobile_filters.addClass('animated fadeOutDownBig');
            $mobile_filters.one('animationend', () => {
                mobile_filters_active = false;
                $mobile_filters.removeClass(
                    'animated event-filters__mobile--active  fadeOutDownBig',
                );
            });
        }
    });

    $container.on('filterChange', () => {
        if (filtering) {
            return;
        }

        filtering = true;

        const { date, type } = filters;
        let body = {};

        if (sticky_active) {
            $('html,body').animate({ scrollTop: window.innerHeight }, 150);
        }

        if (!upcomingCollapsed) {
            collapseUpcomingEvents();
        }

        if (date) {
            switch (date) {
                case 'week':
                    body['start'] = $container.attr('data-week-start');
                    body['end'] = $container.attr('data-week-end');
                    break;
                case 'weekend':
                    body['start'] = $container.attr('data-weekend-start');
                    body['end'] = $container.attr('data-weekend-end');
                    break;
                case 'specific-date':
                    const { day, month, year } = specific_date;
                    body['start'] = `${year}-${month}-${day} 00:00:00`;
                    body['end'] = `${year}-${month}-${day + 1} 00:00:00`;
            }
        }

        if (type) {
            body['tax_query'] = {
                parameters: [
                    {
                        taxonomy: 'aam__event_type',
                        terms: type,
                    },
                ],
            };
        }

        if (!date && !type) {
            resetEvents(() => {
                setText(date, type);
                filtering = false;
            });
        } else if (!date) {
            filterEvents(`${post_url}${offset}`, body, () => {
                setText(date, type);
                filtering = false;
            });
        } else {
            filterEvents(post_url, body, () => {
                setText(date, type);
                filtering = false;
            });
        }
    });

    $(window).on(
        'scroll',
        _.throttle(() => {
            toggleSticky();
        }, 150),
    );

    function filterEvents(url, body = {}, callback) {
        $two_day_container.parent().addClass('two-day-event-feed--loading');
        $two_day_container.addClass('animated fadeOutUp hide');
        $.post(url, body).done(cards => {
            $.post(card_url, { cards }).done(html => {
                callback();
                $two_day_container
                    .parent()
                    .removeClass('two-day-event-feed--loading');
                $two_day_container
                    .find('.card-feed__card--event,.card-no-results')
                    .remove();
                $cards.append(html);
                $two_day_container
                    .removeClass('animated fadeOutUp')
                    .addClass('animated fadeInUp');
                $two_day_container.one('animationend', () => {
                    setTimeLinks();
                    $two_day_container.removeClass('animated fadeInUp');
                });
            });
        });
    }

    function resetEvents(callback) {
        $two_day_container.parent().addClass('two-day-event-feed--loading');
        $two_day_container.addClass('animated fadeOutUp hide');
        $two_day_container.one('animationend', () => {
            callback();
            $two_day_container
                .parent()
                .removeClass(
                    'two-day-event-feed--loading two-day-event-feed--filtered',
                );
            $two_day_container.html($('#two-day-event-feed--backup').html());
            $upcoming.css({ height: '', maxHeight: '', transition: '' });
            $two_day_container
                .removeClass('animated fadeOutUp')
                .addClass('animated fadeInUp');
            $two_day_container.one('animationend', () =>
                $two_day_container.removeClass('animated fadeInUp'),
            );
            resetVariables();
            setTimeLinks();
        });
    }

    function collapseUpcomingEvents() {
        const height = $upcoming.outerHeight(true);
        const transition = `max-height ${height}ms cubic-bezier(0.785, 0.135, 0.15, 0.86)`;

        $two_day_container.parent().addClass('two-day-event-feed--filtered');
        $upcoming.css({ height, maxHeight: height, transition });

        setTimeout(() => {
            $upcoming.css({ maxHeight: 0 });
        }, 10);
    }

    function setText(date, type) {
        const super_title = $(
            '#card-feed--day-one .card-slash .card-slash__supertitle',
        ).first();
        const title = $(
            '#card-feed--day-one .card-slash .card-slash__title',
        ).first();

        if (date && type) {
            const selected_type = $('#select-type option:selected')
                .text()
                .trim();
            switch (date) {
                case 'week':
                    title.css({ display: 'block' }).html('This week');
                    break;
                case 'weekend':
                    title.css({ display: 'block' }).html('This weekend');
                    break;
                case 'specific-date':
                    const { day, month, year } = specific_date;
                    const day_of_week = moment(
                        `${year}/${month}/${day}`,
                        'YYYY-MM-DD',
                    ).format('dddd');
                    const month_day = moment(
                        `${year}/${month}/${day}`,
                        'YYYY-MM-DD',
                    ).format('MMMM D');
                    title
                        .css({ display: 'block' })
                        .html(`${day_of_week},<br/>${month_day}`);
                    break;
            }
            super_title.css({ display: 'block' }).html(selected_type);
        } else if (date) {
            super_title.css({ display: 'none' });
            switch (date) {
                case 'week':
                    title.css({ display: 'block' }).html('This week');
                    break;
                case 'weekend':
                    title.css({ display: 'block' }).html('This weekend');
                    break;
                case 'specific-date':
                    const { day, month, year } = specific_date;
                    const day_of_week = moment(
                        `${year}/${month}/${day}`,
                        'YYYY-MM-DD',
                    ).format('dddd');
                    const month_day = moment(
                        `${year}/${month}/${day}`,
                        'YYYY-MM-DD',
                    ).format('MMMM D');
                    title
                        .css({ display: 'block' })
                        .html(`${day_of_week},<br/>${month_day}`);
                    break;
            }
        } else if (type) {
            const selected_type = $('#select-type option:selected')
                .text()
                .trim();
            super_title.css({ display: 'none' });
            title.html(selected_type);
        }
    }

    function resetVariables() {
        $container = $('.event-filters');
        $filters = $('.event-filters .aam__select-input');
        $two_day_container = $('.two-day-event-feed__wrap');
        $upcoming = $('.card-feed--upcoming-events').first();
        $cards = $two_day_container.find('.card-feed__cards').first();
        $sticky = $('.event-filters--sticky').first();
        two_day_offset = $two_day_container.offset().top;
        two_day_height = $two_day_container.outerHeight(true);
    }

    function toggleSticky() {
        const scrollPos = $(window).scrollTop();
        if (two_day_offset <= scrollPos) {
            $sticky.addClass('event-filters--sticky--active');
            sticky_active = true;
        } else {
            $sticky.removeClass('event-filters--sticky--active');
            $sticky
                .find('.aam__select--expanded')
                .removeClass('aam__select--expanded');
            sticky_active = false;
        }
    }

    function setTimeLinks() {
        _.each($('.card-feed__card--event'), event => {
            const $event = $(event);
            const $links = $event.find('a').not('.card__tag');
            const time = $event.attr('data-time');

            if (time) {
                _.each($links, link => {
                    const $link = $(link);
                    const url = $link.attr('href');

                    if (!url.includes('?time') && !url.includes('?')) {
                        $link.attr('href', `${url}?time=${time}`);
                    } else if (!url.includes('?time') && url.includes('?')) {
                        $link.attr('href', `${url}&time=${time}`);
                    }
                });
            }
        });
    }
});
